// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  IGetLocationBySubdomainRequest,
  TGetLocationBySubdomainModel,
  IMappers,
  TGetLocationBySubdomainResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRegionCityResponse } from '../../entities/response/GetRegionCityResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetLocationBySubdomainModel(
  parameters: IGetLocationBySubdomainRequest,
): TGetLocationBySubdomainModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-temp-layer',
    pathApi: '/v1/get-location-by-subdomain/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetLocationBySubdomainOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetLocationBySubdomainRequest;
}

export async function fetchGetLocationBySubdomain<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetLocationBySubdomainOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetLocationBySubdomainResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetLocationBySubdomainModel(parameters),
    config,
  )) as FetchResponse<TGetLocationBySubdomainResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRegionCityResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetLocationBySubdomainResponse>;
}
